import { 
	HashRouter as Router,
	Switch,
	Route} from 'react-router-dom';
import Home from './Components/Home';
import Detail from "./Components/Detail"
import Navbar from './Components/Navbar';
import "./styles/Global.css"

function App() {

  	return (
	<div className="main">		
		<Navbar/>
		<div className='content'>
			<Router>
				<Switch>
					<Route exact path="/">
						<Home/>
					</Route>
					<Route exact path="/detail/:id">
						<Detail/>
					</Route>
				</Switch>
			</Router>
		</div>
	</div>);
}

export default App;
